// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__31Axk","dragIcon":"SortableItem_dragIcon__3lH0P","disabled":"SortableItem_disabled__1mrwZ"};